import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { Link } from 'react-router'
import FaDown from 'react-icons/lib/fa/angle-down'
import BlueLogo from '../../assets/newblacklogo.png'
import './landing.css'
import StartCard from './Start'
import Features from './Features'
import FooterCTA from './FooterCTA'
import Examples from './Examples'
import Stats from './Stats'
import { processUploadedFiles } from '../../misc/utilities'

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
  viewParams: ownProps.viewParams,
})

class Landing extends Component {
  constructor() {
    super()
    this.state = {
      zoomed: null,
      scrolled: true,
    }

    this.setState = this.setState.bind(this)
  }

  render() {
    const { me } = this.props
    return (
      <Dropzone
        ref="dropzone"
        noClick
        onDrop={(acceptedFiles, rejectedFiles) => {
          processUploadedFiles(this.props.dispatch, acceptedFiles, null, me.plan_max_length)
        }}
      >
        {({getRootProps, getInputProps, isDragActive}) => (
        <div 
          className={`dropzone landing`} 
          {...getRootProps()}
        >
          {isDragActive ? <div className="drop-accepted"><div className="drop-accepted-text">Drop anywhere.</div></div> : ''}
          <input {...getInputProps()} />
          <nav className="navbar navbar-default" ref={r => this.navRef = r}>
            <ul className="nav navbar-nav">
              <li>
                <a href="https://streamable.com" className="nav-btn">
                  <img className="logo" src={BlueLogo} role="presentation" />
                </a>
              </li>
            </ul>
            <ul className="nav navbar-nav float-right">
              <span>
                <li>
                  <Link to="/pricing?src_internal=landing-navbar-link" className="nav-btn pricing-btn">
                    Pricing
                  </Link>
                  <Link to="/login" className="nav-btn login-btn">
                    Log In
                  </Link>
                  <Link to="/signup?signup_src=landing" className="nav-btn signup-btn">
                    Sign Up
                  </Link>
                </li>
              </span>
            </ul>
          </nav>
          <StartCard />
          <div className="more-arrow">
            <div className="more-arrow-description">Scroll</div>
            <FaDown />
          </div>
          <Features />
          <Examples />
          <Stats />
          <FooterCTA />
          <footer className="footer">
            <div className="container-fluid">
              <ul className="nav navbar-nav">
                <li>
                  <a href="//privacy.streamable.com">
                    Privacy
                  </a>
                </li>
                <li>
                  <a href="//terms.streamable.com">
                    Terms
                  </a>
                </li>
                <li>
                  <a href="https://support.streamable.com">
                    Support
                  </a>
                </li>
              </ul>
            </div>
          </footer>
        </div>
        )}
      </Dropzone>
    )
  }
}

export default connect(mapStateToProps)(Landing)
